const url = "https://data.bankradar.com/process-mortgage/internal/";

export function handleRedirection(redirectReason) {
  const query = new URLSearchParams(window.location.search);
  let fullQueryString = '?' + query.toString();

  let redirectPartner = "ICB";
  let url = `https://ratezip.com/loanrates/rt-v2/${fullQueryString}`;

  if (redirectReason === "age") {
    redirectPartner = "MRC";
    url = `https://homeequity.ratezip.com/flows/heloc${fullQueryString}`;
  }

  if (redirectReason === "state") {
    redirectPartner = "MRC";
    url = `https://www.ratezip.com/tables/mrc/${fullQueryString}`;
  }

  if (redirectReason === "homeValue") {
    redirectPartner = "MRC";
    url = `https://www.ratezip.com/tables/mrc/${fullQueryString}`;
  }

  if (redirectReason === "Longbridge offer") {
    window.dataLayer.push({
      event: "xltPixel",
    });

    redirectPartner = "Longbridge";
    url = `https://www.ratezip.com/rate-quotes/redirects/longbridge/${fullQueryString}`;
  }

  if (redirectReason === "ltv") {
    redirectPartner = "MRC";
    url = `https://www.ratezip.com/tables/mrc/${fullQueryString}`;
  }

  if (window.location.href.includes("/for-purchase")) {
    redirectPartner = "MRC";
    const qs = fullQueryString + '&desc=purchase';
    url = `https://www.ratezip.com/tables/mrc/${qs}`;
  }

  window.dataLayer.push({
    redirect_partner: redirectPartner,
    redirect_reason: redirectReason,
    event: "userRedirect",
  });

  setTimeout(() => {
    window.location.replace(url || "http://ratezip.com/");
  }, 400);
}

export function buildFormData(state, jornaya, trustedForm, verification) {
  const data = {
    ppcid: state.ppcid,
    cid: state.cid,
    gclid: state.gclid,
    tsid: state.tsid,
    productname: "Reverse",
    zipcode: state.zipCode,
    city: state.city,
    state: state.state,
    addressone: state.address,
    firstname: state.firstName,
    lastname: state.lastName,
    balance: String(state.mortgageBalance > 2000000 ? 2000000 : state.mortgageBalance),
    ownerdob: "1940-04-15",
    ownerage: String(state.age),
    phonenumber: state.phoneNumber,
    emailaddress: state.email,
    propvalue: String(state.homeValue < 100000 ? 100000 : state.homeValue),
    trustedformcert: trustedForm,
    jornayatoken: jornaya,
    verificationstatus: verification,
    lander: state.isAppointment ? "guild-appointment" : "flyreverse-2",
    fullurl: window.location.href,
    militaryveteran: "No",
    creditrating: "Good",
    selfemployed: "No",
    propertytype: "Single Family Residence",
    return_buyer: "Yes"
  };

  if (window.location.href.toString().includes("localhost")) {
    data.test_lead = "Yes";
    data.verificationstatus = "Yes";
  }

  return data;
}

export async function submitWrapper(state, step, isVerified) {
  const { jornaya, trustedForm } = getCertValues();

  let verification = isVerified ? "Yes" : "No";

  if (window.location.href.includes("localhost")) {
    verification = "Yes";
  }

  const fd = buildFormData(state, jornaya, trustedForm, verification);
  let { salesValue, buyer } = await makePostRequest(fd);

  if (window.location.href.includes("localhost")) {
    const params = new URLSearchParams(window.location.search);
    const mockBuyer = params.get("mock_buyer");
    if (mockBuyer) buyer = mockBuyer;
  }

  handleLeadSaleEvents(salesValue, step);

  return buyer;
}

export async function makePostRequest(fd) {
  try {
    const response = await fetch(url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fd),
      redirect: "follow",
    });

    const result = await response.json();

    const { status, price, buyer } = result;

    if (status.toLowerCase() === "matched") {
      return {
        salesValue: +price,
        buyer: buyer,
      };
    } else {
      return {
        salesValue: 0,
        buyer: null,
      };
    }
  } catch (error) {
    return {
      salesValue: 0,
      buyer: null,
    };
  }
}

export function handleLeadSaleEvents(salesValue, step) {
  if (+salesValue !== 0) {
    window.dataLayer.push({
      sale_price: salesValue,
      event: "leadSale",
    });
    window.dataLayer.push({
      flow_step: step,
      flow_description: "Thank You - Sold Lead",
      event: "stepChange",
    });

    return;
  }

  window.dataLayer.push({
    sale_price: 0,
    event: "unsoldLead",
  });
  window.dataLayer.push({
    flow_step: step,
    flow_description: "Thank You - Unsold Lead",
    event: "stepChange",
  });
}

export function getCertValues() {
  const jornayaCertValue = document.getElementById("leadid_token").value;
  const trustedFormElementNodeList =
    document.getElementsByName("xxTrustedForm");

  const trustedFromCertValue = trustedFormElementNodeList[0]?.value || "";

  return {
    jornaya: jornayaCertValue,
    trustedForm: trustedFromCertValue,
  };
}
